import Admin from "@system/config/admin";
import Helper from "src/helper/Helper";
import Api from "../APIHandler";

const API = new Api({});

class UserAPICall {

    getUserList = async (params = {}) => {
        let res = { count: 0, records: [] };
        let param = {}
        param.data = params
        await API.post(Admin.USER_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull && resHer.data?.data?.users) {
                res = resHer.data.data;
            }
        });

        return res;
    };

    deleteUsers = async (params = {}) => {
        let param = {}
        param.data = params
        return await API.post(Admin.DELETE_USERS, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
            }
        });
    };

    exportUserList = async (params = {}) => {
        let param = {}
        param.data = params
        param.data.responseType = "blob"
        let res = {};
        await API.post(Admin.EXPORT_USER_LIST, param).then((resHer) => {
            if (resHer?.data) {
                Helper.downloadFileFromRes(resHer.data, "user_list.xlsx");
            }
        });
        return res;
    };

    emailUserList = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.EMAIL_USER_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res.msg = resHer.data.data;
            }
        });
        return res;
    };

    addUser = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        try {
            await API.post(Admin.ADD_USER, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data;
                    res.username = params.firstName + " " + params.lastName;
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };

    getUserDetail = async (userId) => {
        let res = {};
        let param = {}
        param.params = { 'userId': userId }
        await API.post(Admin.GET_USER_DETAIL, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data;
            }
        });
        return res;
    };

    getWebUserShippingAdrress = async (userId) => {
        let res = {};
        let param = {}
        param.params = { 'userId': userId }
        await API.post(Admin.GET_WEB_USER_SHIPPING_ADDRESS_DETAIL, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data;
            }
        });
        return res;
    };

    saveUserShippingAdrress = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.SAVE_WEB_USER_SHIPPING_ADDRESS + `/${params.id}`, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data;
            }
        });
        return res;
    };

    getUserAcctList = async (userId) => {
        let res = { count: 0, records: [] };
        let param = {}
        param.params = { 'users': userId }

        await API.post(Admin.GET_USER_ACCT_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = {
                    count: resHer.data.length,
                    records: resHer.data.data
                };
            }
        });
        return res;
    };

    getUserSearchAcctList = async (params = {}) => {
        let res = { count: 0, records: [] };
        let param = {}
        param.data = params
        await API.get(Admin.GET_USER_SEARCH_ACCT_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull && resHer.data?.data) {
                res = {
                    count: resHer.data.length,
                    records: resHer.data.data,
                };
            }
        });
        return res;
    };

    updateUserAcctSponsorship = async (params = {}) => {
        let res = { count: 0, records: [] };
        let param = {}
        param.data = params
        await API.post(Admin.UPDATE_USER_SPONSORSHIP, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data
            }
        });
        return res;
    };

    updateUnsponsorUserAcct = async (params = {}) => {
        let res = false;
        let param = {}
        param.data = params
        await API.post(Admin.UPDATE_USER_UNSPONSOR_ACCT, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = true
            }
        });
        return res;
    };

    updateUserDetail = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.UPDATE_USER_DETAIL, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
            }
        });
        return res;
    };

    checkUserEmail = async (params = {}) => {
        let res = {};
        let param = {}
        param.params = { 'emailId': params }
        try {
            await API.post(Admin.CHECK_USER_EMAIL, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };

    updateUserActiveStatus = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.UPDATE_USER_ACTIVE_STATUS, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
            }
        });
        return res;
    };

    searchSponsorAccounts = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.SEARCH_SPONSOR_ACCOUNTS, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer;
                if (res?.data?.data?.accountList.length > 0) {
                    res?.data?.data?.accountList.forEach((ele, i) => {
                        ele.key = i
                    })
                }
            }
        });
        return res;
    };

    updateUserRoles = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.EDIT_USER_ROLES, param).then((resHer) => {
            res = resHer.data;
        }).catch((err) => {
            res = err.response.data;
        })
        return res;
    };

}

export default UserAPICall;